import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { productColor, nozzleLabel } from "@/lib/products";

export default function ReadingsGrid({ values, onChange, disabled = false, opening, prefix = "reading", products }) {
  return (
    <div className="space-y-5">
      {products.map((p, pi) => (
        <div key={p.key} className="rounded-xl border border-slate-200 border-l-4 bg-white p-4" style={{ borderLeftColor: productColor(pi) }}>
          <div className="text-sm font-semibold text-slate-700 mb-3">{p.name} <span className="text-xs text-slate-400 font-normal">· {p.unit}</span></div>
          <div className="grid grid-cols-2 gap-3">
            {p.nozzles.map((nz, i) => {
              const openVal = opening?.[nz];
              return (
                <div key={nz} className="space-y-1.5">
                  <div className="flex items-center justify-between">
                    <Label htmlFor={`${prefix}-${nz}`} className="text-xs uppercase tracking-wide text-slate-500">{nozzleLabel(p, i)}</Label>
                    {openVal !== undefined && (
                      <span className="text-[10px] text-slate-400 font-mono-num">open {Number(openVal).toFixed(2)}</span>
                    )}
                  </div>
                  <Input
                    id={`${prefix}-${nz}`}
                    data-testid={`${prefix}-${nz}`}
                    disabled={disabled}
                    type="number"
                    step="0.01"
                    min={openVal !== undefined ? openVal : 0}
                    inputMode="decimal"
                    value={values[nz] ?? ""}
                    onChange={(e) => onChange(nz, e.target.value)}
                    className="h-14 rounded-xl text-lg font-mono-num tracking-tight"
                    placeholder="0.00"
                    required
                  />
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
